import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

import { useHealthlinkPractice } from "./useHealthlinkPractice";

/**
 * Resolves whether the current tenant has a usable HealthLink practice setup.
 *
 * - `isHealthlinkEnabled`: HealthLink is turned on in practice settings.
 * - `isConfigured`: enabled AND a practice certificate exists — HealthLink
 *   features can be used.
 * - `isMisconfigured`: enabled but no practice certificate configured
 *   (`GET /healthlink/practice` -> 404 -> null). A valid state (manual
 *   vaccines still work), but HealthLink submission is unavailable, so
 *   consumers should hide HealthLink surfaces and prompt for configuration.
 */
export const useHealthlinkPracticeStatus = () => {
  const { data: practiceSettings } = usePracticeSettings();
  const isHealthlinkEnabled =
    !!practiceSettings && practiceSettings.healthLink !== false;

  const { data: healthlinkPractice, isLoading } = useHealthlinkPractice();

  const isConfigured = isHealthlinkEnabled && !!healthlinkPractice;
  const isMisconfigured =
    isHealthlinkEnabled && !isLoading && !healthlinkPractice;

  return { isHealthlinkEnabled, isConfigured, isMisconfigured, isLoading };
};
